export default angular
  .module("FunctionCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("FunctionController", [
    "$location",
    "$scope",
    "$stateParams",
    "System",
    "$rootScope",
    function ($location, $scope, $stateParams, System, $rootScope) {
      if (!$rootScope.commonFunctions) {
        $rootScope.commonFunctions = {
          pageSize: 20,
          currentPage: 1,
          filter: undefined,
        };
      }

      const emptyFunction = {
        ID: undefined,
        NAME: "",
        CODE: "",
        STATUS: "test",
      };

      $scope.pageSize = 20;
      $scope.statusFilter = "all";
      $scope.activeSort = {
        column: "NAME",
        direction: false, // Descending
      };
      $scope.functionId = $stateParams.functionId && parseInt($stateParams.functionId, 10);

      $scope.functionData = [];
      $scope.activeFunction = undefined;
      System.loadFunctions((data) => {
        $scope.functionData = data;
      });

      if ($scope.functionId) {
        System.loadFunctionById($scope.functionId, (data) => {
          $scope.activeFunction = data || emptyFunction;
          $("#function-list-content").collapse("hide");
        });
      } else {
        $scope.activeFunction = emptyFunction;
      }

      $scope.changeSorting = (column) => {
        if ($scope.activeSort.column === column) {
          $scope.activeSort.direction = !$scope.activeSort.direction;
        } else {
          $scope.activeSort.column = column;
          $scope.activeSort.direction = false;
        }
      };

      $scope.openFunctionEdit = (ID) => {
        $location.path(`/functions/${ID}`);
      };

      $scope.closeFunctionEdit = () => {
        $location.path("/functions");
      };

      $scope.saveFunction = () => {
        if ($scope.functionId) {
          System.editFunction($scope.activeFunction, () => {
          });
        } else {
          System.addFunction($scope.activeFunction, (record) => {
            $location.path(`/functions/${record.ID}`);
          });
        }
      };

      $scope.aceOptions = {
        required: ["ace/ext/language-tools"],
        advanced: {
          enableSnippets: true,
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          wrap: true,
        },
        mode: "javascript",
        theme: "github",
        showPrintMargin: false,
      };

      const setPage = (page) => {
        $rootScope.commonFunctions.currentPage = page;
      };

      $scope.filterChanged = function () {
        setPage(1);
      };

      $scope.pageChanged = setPage;
    },
  ]);
